import { ScanButton } from "components/Picklist/common/ScanButton";
import React from "react";
import { Inventory } from "types/inventory";
import { useRevalidator } from "react-router-dom";
interface ScanAndConfirmInventoryButtonProps {
  inventory: Inventory;
  onError: () => void;
  onSuccess: () => void;
}

export const ScanAndConfirmInventoryButton = ({
  inventory,
  onError,
  onSuccess,
}: ScanAndConfirmInventoryButtonProps) => {
  const { revalidate } = useRevalidator();

  return (
    <ScanButton
      onScan={async (scanValue) => {
        if (scanValue) {
          if (inventory.id.toString() !== scanValue) {
            onError();
          } else {
            revalidate();
            onSuccess();
          }
        }
      }}
    >
      Scan Label
    </ScanButton>
  );
};
